const URL = '  https://food-mafia-server.herokuapp.com/api/review';

export const createReview = (review) =>
    fetch(URL, {
        method: 'POST',
        body: JSON.stringify(review),
        headers: {
            'content-type': 'application/json'
        }
    }).then(response => response.json());

export const findAllReviews = (hotelId) =>
    fetch(`${URL}/restaurant/${hotelId}`)
        .then(response => response.json());

// Added by Savitha
export const findAllUserReviews = (userId) =>
    // console.log(userId);
    fetch(`${URL}/user/${userId}`)
        .then(response => response.json());

export const deleteReview = (rid) =>
    fetch(`${URL}/${rid}`, {
        method: 'DELETE',
    });

const reviewService = {
    createReview, findAllReviews, deleteReview, findAllUserReviews
}
export default reviewService;
